import Page from '../components/Page';
import { DevicesMap } from '../components/device/DevicesMap';
import { Fragment, useState } from 'react';
import { Device } from '../@types/model/device';
import DeviceGridTable from 'components/device/DeviceGridTable';
import { DevicesMapRepsolB2B } from 'components/device/DevicesMapRepsolB2B';
import { RootState, useSelector } from './../redux/store';
import DeviceTable from 'components/device/DeviceTable';
import DeviceTableRepsol from 'components/device/DeviceTableRepsol';
import LoadingSpinner from 'components/LoadingSpinner';
import { checkWorkspace, WORKSPACES_REPSOL } from 'guards/CheckRoles';
import { useTranslation } from 'react-i18next';

const DashboardHomeEndUser = () => {
  const [devices, setDevices] = useState<Device[]>([]);
  const { workspace } = useSelector((state: RootState) => state.workspace);
  const { t } = useTranslation();

  return (
    <Page title={'Giraf'}>
      {workspace && checkWorkspace(workspace, WORKSPACES_REPSOL) && (
        <DevicesMapRepsolB2B height={400} devices={devices} />
      )}
      {workspace && !checkWorkspace(workspace, WORKSPACES_REPSOL) && workspace?.wsName !== '' && (
        <DevicesMap height={400} devices={devices} />
      )}
      {workspace ? (
        <Fragment>
          {workspace && checkWorkspace(workspace, WORKSPACES_REPSOL) && (
            <DeviceTableRepsol
              onFilterChange={(devices: Device[]) => {
                setDevices(devices);
              }}
              filterDevices={true}
            />
          )}
          {workspace && !checkWorkspace(workspace, WORKSPACES_REPSOL) && workspace?.wsName !== '' && (
            <DeviceGridTable
              onFilterChange={(devices: Device[]) => {
                setDevices(devices);
              }}
              title={t('devices')}
              pagination={false}
            />
          )}
        </Fragment>
      ) : (
        <Fragment>
          <LoadingSpinner />
        </Fragment>
      )}
    </Page>
  );
};

export default DashboardHomeEndUser;
